<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4 v-if="isNewFlow">NOVO FLUXO BOT</h4>
      <h4 v-else>{{ this.chatOption.id === null ? "ADICIONAR NOVA" : "ATUALIZAR" }} OPÇÃO</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      />
    </div>
    <vs-divider class="mb-0"/>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div v-if="!isMainMessage && !isNewFlow">
          <div 
            data-v-7c55cca8="" 
            class="con-select w-full" 
            v-if="
              (
                (chatOption.number == null) ||
                (chatOption.only_child && chatOption.number <= 1 )
              ) &&
              !isLastMessage
            "
          >
            <label for="" class="vs-select--label">Tipo de interação</label>
            <div class="input-select-con">
              <select :disabled="backToPreviousOption" v-model="selectedInteractionType" class="input-select vs-select--input">
                <option class="vs-select--item" value="0">Opção</option>
                <option class="vs-select--item" value="1">Texto</option>
              </select>
            </div>
          </div>

          <div 
            class="mr-3 w-full" 
            v-if="!isLastMessage && !!parseInt(selectedInteractionType) == 0"
          >
            <!-- Option Number -->
            <vs-input label="Número" v-model="chatOption.number" class="w-full mr-3" name="number" :disabled="true" />
          </div>

          <div 
            v-if="!isNewFlow && chatOption.has_department_redirect && departamentSelected !== null && !backToPreviousOption"
            class="flex flex-row w-full"
          >
            <!-- Departament Active -->
            <vs-input label="Departamento" class="w-full" :value="departamentSelected" :disabled="true" />
    
            <div 
              v-if="chatOption.is_original_department"
              class="hover:text-primary stroke-current mt-4 p-2"
              @click.stop="setEdit('departament')"
            >
              <!-- Departament Edit -->
              <feather-icon class="flex flex-center items-center" icon="EditIcon" svgClasses="w-5 h-5" />
              <label class="text-sm">Editar</label>
            </div>

            <div 
              v-if="chatOption.is_original_department"
              class="hover:text-danger stroke-current mt-4 p-2"
              @click.stop="setUnlink('user_department_id')"
            >
              <!-- Departament Unlink -->
              <feather-icon class="flex flex-center items-center " icon="TrashIcon" svgClasses="w-5 h-5" />
              <label class="text-sm">Desvincular</label>
            </div>
          </div>

          <div
              v-if="!isNewFlow && settingPriority && prioritySelected !== null && !backToPreviousOption"
              class="flex flex-row w-full"
          >
            <!-- Priority Active -->
            <vs-input label="Prioridade" class="w-full" :value="prioritySelected" :disabled="true" />

            <div
                v-if="chatOption.is_original_priority"
                class="hover:text-primary stroke-current mt-4 p-2"
                @click.stop="setEdit('priority')"
            >
              <!-- Priority Edit -->
              <feather-icon class="flex flex-center items-center" icon="EditIcon" svgClasses="w-5 h-5" />
              <label class="text-sm">Editar</label>
            </div>

            <div
                v-if="chatOption.is_original_priority"
                class="hover:text-danger stroke-current mt-4 p-2"
                @click.stop="setUnlink('priority')"
            >
              <!-- Priority Unlink -->
              <feather-icon class="flex flex-center items-center" icon="TrashIcon" svgClasses="w-5 h-5" />
              <label class="text-sm">Desvincular</label>
            </div>
          </div>

          <vs-checkbox v-model="backToPreviousOption" v-if="chatOption.back_option_is_active && !isLastMessage && selectedInteractionType == 0 && chatOption.parent_has_options && !chatOption.current_node_has_back_option" class="mt-4">
            Voltar para opção anterior
          </vs-checkbox>

          <!-- Last Message -->
          <div
            v-if="
              !backToPreviousOption &&
              !chatOption.hide_last_checkbox &&
              !chatOption.children &&
              chatOption.only_child
            "
            style="justify-content:right;"
            class="w-9/12 mb-5"
          >
            <label>&nbsp;</label>
            <vs-checkbox v-model="isLastMessage" v-if="!backToPreviousOption">
              Mensagem Final
            </vs-checkbox>
          </div>

          <p
            v-if="(!chatOption.id || !chatOption.number) && !chatOption.hide_last_checkbox && isLastMessage"
            class="text-grey-darker mt-3"
          >
            Mensagem final encerrará o fluxo do Bot de Conversa,
            portanto ela é uma mensagem única de resposta e não é necessário
            ter um número atrelado
          </p>
        </div>

        <div class="mt-2">
          <!-- Departament Redirect Switch and Unlink All Department Flow-->
          <div
            v-if="!chatOption.number && !chatOption.parent_option_id && chatOption.type !== 1"
            class="items-center"
          >
            <div class="p-5 mt-1 mb-5 settings-flow-panel">
              <div class="flex align-items-center">
                <vs-switch v-model="chatOption.has_department_redirect" @click.prevent="unlinkAllDepartment()">
                  <span slot="on">Ativo</span>
                  <span slot="off">Inativo</span>
                </vs-switch>

                <label class="vs-input--label">
                  Departamento
                </label>

                <div class="ml-2" title="Essa funcionalidade permite a configuração de departamentos no fluxo do bot. Quando um contato selecionar um departamento, ele é transferido automaticamente e ficará disponível para interações dentro da escolha.">
                  <feather-icon icon="HelpCircleIcon" svg-classes="w-4 h-4"/>
                </div>
              </div>
              <div class="flex mt-3 align-items-center" v-if="hasCloud">
                <vs-switch v-model="settingButtons">
                  <span slot="on">Ativo</span>
                  <span slot="off">Inativo</span>
                </vs-switch>

                <label class="vs-input--label">
                  Conversão do fluxo para Interativo
                </label>

                <div class="ml-2" title="Essa função permite a conversão de opções numéricas em botões/lista de botões apenas para as conexões Cloud. Ao ativar, certifique-se de que cada opção não ultrapasse 20 caracteres. Se necessário, um aviso será exibido para orientar ajustes.">
                  <feather-icon icon="HelpCircleIcon" svg-classes="w-4 h-4"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Available Departments -->
          <vs-select v-model="chatOption.user_department_id" label="Departamentos" class="mt-4 mb-4 w-full" name="department" v-if="
              !backToPreviousOption &&
              ((
                departamentSelected === null &&
                chatOption.parent_user_department === null
              ) &&
                !isNewFlow && chatOption.has_department_redirect && chatOption.parent_option_id) ||
                presets.departament.edit
            " autocomplete>
            <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in departmentChoices" />
          </vs-select>

          <vs-select v-model="chatOption.priority" label="Prioridade no Atendimento" class="mt-4 mb-4 w-full" name="priority" v-if="
            !backToPreviousOption && chatOption.type === 0 && settingPriority &&
            ((
              prioritySelected === null &&
              chatOption.parent_priority === null
            ) &&
              !isNewFlow && chatOption.parent_option_id) ||
              presets.priority.edit
          " autocomplete>
            <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in priorityTypes" />
          </vs-select>

          <div v-if="!isNewFlow && !backToPreviousOption && chatOption.type === 0 && chatOption.parent_option_id">
            <vs-divider position="center" class="mt-5 mb-0">
              Configurações Adicionais
            </vs-divider>

            <vs-collapse class="select-none p-0 mb-3" accordion>
              <vs-collapse-item>
                <div slot="header" class="flex">
                  <feather-icon icon="GridIcon" class="mr-2" svgClasses="h-5 w-5"/>
                  <small>Inserção em Categoria</small>
                </div>

                <div v-if="chatOption.is_original_group || !groupSelected" class="flex align-items-center w-full">
                  <vs-select
                    autocomplete
                    name="category"
                    class="w-full"
                    label="Vincular a Categoria"
                    v-model="chatOption.parent_group"
                    @input="setGroup"
                  >
                    <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in groups" />
                  </vs-select>

                  <div class="hover:text-danger stroke-current mt-4 p-4" @click="setUnlink('group_id')">
                    <feather-icon class="flex flex-center items-center" icon="TrashIcon" svgClasses="w-5 h-5" />
                  </div>
                </div>
                <div v-else>
                  <vs-input label="Categoria" class="w-full" :value="groupSelected" :disabled="true" />
                </div>
              </vs-collapse-item>

              <vs-collapse-item v-if="settingKnowledge && !isLastMessage && selectedInteractionType == 1">
                <div slot="header" class="flex">
                  <feather-icon icon="UserIcon" class="mr-2" svgClasses="h-5 w-5"/>
                  <small>Integrar a Modelo de Dados</small>
                </div>

                <div class="align-items-center w-full">
                  <div class="flex mb-2">
                    <vs-select
                      autocomplete
                      name="knowledge"
                      class="w-full"
                      label="Vincular ao Modelo"
                      :key="'knowledge1' + componentKey"
                      v-model="chatOption.reason_id"
                      @input="setKnow"
                    >
                      <vs-select-item :key="item.id" :value="item.id" :text="item.description" v-for="item in knowledge" />
                    </vs-select>

                    <div class="hover:text-danger stroke-current mt-4 p-4" @click="setUnlink('reason_option_id')">
                      <feather-icon class="flex flex-center items-center" icon="TrashIcon" svgClasses="w-5 h-5" />
                    </div>
                  </div>

                  <vs-select
                    name="knowledge"
                    class="w-full"
                    label="Selecione uma pergunta do tipo 'Texto'"
                    :key="'knowledge2' + componentKey"
                    :disabled="!optionsknowledge.length"
                    v-model="chatOption.reason_option_id"
                  >
                    <vs-select-item :key="item.id" :value="item.id" :text="item.description" v-for="item in optionsknowledge"/>
                  </vs-select>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>

          <label class="vs-input--label" v-if="isNewFlow">Primeira Mensagem</label>
          <label class="vs-input--label" v-else>Descrição da Opção</label>

          <vs-textarea
            rows="12"
            class="vs-textarea"
            style="border: 1px solid #ccc;"
            v-model="chatOption.description"
            :counter="canShowButton ? '20' : ''"
            :maxlength="canShowButton ? '20' : ''"
          />

          <vs-alert
            v-if="!isNewFlow && clearAllFlowDepartment"
            style="height: fit-content;"
            title="Aviso"
            active="true"
            class="mb-8 mt-8"
            color="warning"
          >
            <span>Ao salvar, se houverem departamentos vinculados no fluxo do Bot eles serão <b>retirados completamente</b> de forma automática. </span>
          </vs-alert>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
        Salvar
      </vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">
        Cancelar
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleChatFlow from '@/store/chatFlow/moduleChatFlow'
import moduleUserDepartment from "@/store/userDepartment/moduleUserDepartment"
import chatFlow from "@/http/requests/chatFlow"
import {hasFeature, hasCloud} from "@/utils";
import vSelect from "vue-select";

export default {
  name: 'chat-option-view-sidebar',
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    chatOption: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          number: '',
          description: '',
          parent_option_id: null,
          user_department_id: null,
          hide_last_checkbox: false,
          back_option_is_active: false,
          has_department_redirect: false,
          parent_user_department: null,
          is_original_priority: false,
          is_original_department: false,
          clear_all_flow_department: false,
          current_node_has_back_option: false,
          parent_has_options: false,
          only_child: false,
          is_close: null,
        }
      }
    }
  },
  data() {
    return {
      componentKey: 0,
      selectedInteractionType: 0,
      hasCloud: false,
      isNewFlow: false,
      hasFeatures: false,
      settingButtons: false,
      isLastMessage: false,
      isMainMessage: false,
      originalNumber: null,
      numberBeforeChange: null,
      backToPreviousOption: false,
      clearAllFlowDepartment: false,
      interactionTypes: ['Opção', 'Texto Aberto'],
      priorityTypes: [
        {
          text: 'Alta',
          value: 3
        },
        {
          text: 'Média',
          value: 2
        },
        {
          text: 'Baixa',
          value: 1
        }
      ],
      presets: {
        departament: {
          edit: false
        },
        priority: {
          edit: false
        },
        category: {
          edit: false
        }
      },
      startValue: {
        id: null,
        type: null,
        number: '',
        priority: null,
        group_id: null,
        is_close: false,
        description: '',
        parent_option_id: null,
        reason_option_id: null,
        user_department_id: null,
        has_department_redirect: false,
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
    }
  },
  watch: {
    isLastMessage: function (isLastMessage) {
      if (!this.originalNumber) {
        this.originalNumber = this.chatOption.number
      }

      if (isLastMessage) {
        this.setKnow(null)
        this.chatOption.number = null
        this.chatOption.is_close = true
      } else {
        this.chatOption.number = this.originalNumber ?  this.originalNumber : 1
        this.chatOption.is_close = false
      }
    },
    selectedInteractionType: function(selectedInteractionType) {
      if (selectedInteractionType == 0 && !this.chatOption.number && !this.backToPreviousOption) {
        this.chatOption.number = 1;
        this.setKnow(null)
      }
    },
    chatOption: {
      handler(option) {
        this.componentKey++
        const that = this;
        let departament, priority, group;
        const { id, number, description, parent_user_department, parent_option_id, parent_priority, parent_group, children, only_child } = option

        that.chatOption.is_original_group = !!parent_group
        that.chatOption.is_original_priority = !!parent_priority
        that.chatOption.is_original_department = !!parent_user_department

        this.isNewFlow = !id && number === null && !parent_option_id;

        if (parent_option_id !== null) {
          chatFlow.fetch({ id: parent_option_id }).then(response => {
            group = this.findInObject(option, response.data.data.chatOptions[0], 'group')
            priority = this.findInObject(option, response.data.data.chatOptions[0], 'priority')
            departament = this.findInObject(option, response.data.data.chatOptions[0], 'user_department')

            that.chatOption.only_child = response.data.data.chatOptions[0].childOptions.length <= 1
            that.chatOption.has_department_redirect = response.data.data.chatOptions[0].has_department_redirect

            that.chatOption.parent_priority = priority ? priority.priority : null
            that.chatOption.parent_user_department = departament ? departament.user_department : null
            that.chatOption.parent_group = group ? group.group : ( that.chatOption.parent_group || null )

            that.chatOption.is_original_group = (group && id === group.id || !group) && !!parent_group
            that.chatOption.is_original_priority = (priority && id === priority.id || !priority) && !!parent_priority
            that.chatOption.is_original_department = (departament && id === departament.id || !departament) && !!parent_user_department

            that.$forceUpdate()
          })
        } else if (id !== null) {
          chatFlow.fetch({ id: id }).then(response => {
            that.chatOption.has_department_redirect = response.data.data.chatOptions[0].has_department_redirect
            that.$forceUpdate()
          })
        }

        if (id && number === null && !parent_option_id) {
          this.isMainMessage = true
        } else {
          this.isMainMessage = false

          if (number !== null) {
            this.isLastMessage = false
            this.chatOption.description = description.replace(`${number} - `, '');
          } else {
            if (parent_option_id && children || only_child) {
              this.selectedInteractionType = 1
            }
            else if (parent_option_id && !children) {
              this.isLastMessage = true
            }
          }
        }
      },
      immediate: true
    },
    backToPreviousOption(value) {
      if (value) {
        this.numberBeforeChange = this.chatOption.number;
        this.chatOption.number  = this.selectedInteractionType = 0;

        if (this.chatOption.description.trim() === '') {
          this.chatOption.description = !this.settingButtons ? 'Voltar para opção anterior' : 'Voltar';
        }
      }

      if (!value) {
        this.chatOption.number = this.numberBeforeChange === null ? 1 : this.numberBeforeChange;
      }
    }
  },
  computed: {
    departments() {
      return this.$store.state.userDepartment.userDepartments
    },
    groups(){
      return this.$store.state.customerGroup ? this.$store.state.customerGroup.groupsOfCustomerResume : []
    },
    knowledge(){
      return this.$store.state.reasons ? this.$store.state.reasons.reasons : []
    },
    settingPriority(){
      return !!parseInt(this.$store.state.settings.settings.priority_tickets_in_passive_flow)
    },
    settingKnowledge(){
      return this.hasFeatures && !!parseInt(this.$store.state.settings.settings.alloy_sleep_passive_flow)
    },
    departamentSelected() {
      const departament = this.departmentChoices.filter((e) => {return e.value === this.chatOption.parent_user_department})[0]
      return departament ? departament.text : null
    },
    prioritySelected() {
      const priority = this.priorityTypes.filter((e) => {return e.value === this.chatOption.parent_priority})[0]
      return priority ? priority.text : null
    },
    groupSelected() {
      const group = this.groups.filter((e) => {return e.id === this.chatOption.parent_group})[0]
      return group ? group.name : null
    },
    canShowButton(){
      return this.settingButtons && parseInt(this.selectedInteractionType) === 0 && (!!this.chatOption.number || this.chatOption.number === 0)
    },
    optionsknowledge(){
      if ( !this.chatOption.reason_id ) return [];
      const knowledge = this.knowledge.filter((know) => know.id === this.chatOption.reason_id)[0];
      return knowledge['reason_options'].filter((options) => options.reason_option_kind
          && options.reason_option_kind.tag === 'text')
    },
    departmentChoices() {
      const departmentChoices = []

      for (const department of this.departments) {
        if (department.activated === true) {
          departmentChoices.push({
            text: department.name,
            value: department.id
          })
        }
      }

      return departmentChoices
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.setInitValues()
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    }
  },
  methods: {
    unlinkAllDepartment(){
      this.chatOption.has_department_redirect = !this.chatOption.has_department_redirect

      if (!this.chatOption.has_department_redirect && !this.isNewFlow){
        this.chatOption.clear_all_flow_department = true
      } else if (this.chatOption.has_department_redirect &&!this.isNewFlow)  {
        this.chatOption.clear_all_flow_department = false
      }

      this.clearAllFlowDepartment = this.chatOption.clear_all_flow_department
      this.$forceUpdate()
    },
    setInitValues() {
      this.chatOption = JSON.parse(JSON.stringify(this.startValue))
    },
    setEdit(type){
      this.presets[type].edit = !this.presets[type].edit
    },
    setGroup(value){
      this.chatOption.group_id = value
      this.chatOption.is_original_group = true
    },
    setKnow(value){
      this.chatOption.reason_id = value
      this.chatOption.reason_option_id = null
    },
    setUnlink(type){
      const withoutId = type.replace(/_id$/, '');
      const parentName = `parent_${withoutId}`;
      this.chatOption[type] = null;
      this.chatOption[parentName] = null;
      if (type === 'reason_option_id'){
        this.chatOption['reason_id'] = null;
      }
    },
    recursiveObject(option, find) {
      if ( !option || !option.id ) {
        return null
      }

      const name = find.replace(/_([a-z])/g, (_, match) => match.toUpperCase());

      if ( option.id && option[name] ){
        if ( typeof option[name] === 'object' ){
          return {
            id: option.id,
            [find]: option[name].id
          }
        } else {
          return {
            id: option.id,
            [find]: option[name]
          }
        }
      }

      return this.recursiveObject(option.parentOption, find);
    },
    findInObject(defaultOption, responseOption, find = 'user_department'){
      const name = find.replace(/_([a-z])/g, (_, match) => match.toUpperCase());
      const parentName = `parent_${find}`;

      if ( !responseOption[name] && !responseOption.parentOption && !defaultOption[parentName] ){
        return null
      }

      if ( responseOption.parentOption && !responseOption[name] ){
        const rec = this.recursiveObject(responseOption.parentOption, find);
        if (rec) return rec;
      }

      if ( responseOption.id && responseOption[name] ){
        if ( typeof responseOption[name] === 'object' ){
          return {
            id: responseOption.id,
            [find]: responseOption[name].id
          }
        } else {
          return {
            id: responseOption.id,
            [find]: responseOption[name]
          }
        }
      }

      if ( defaultOption.id && defaultOption[parentName] ) {
        return {
          id: defaultOption.id,
          [find]: defaultOption[parentName]
        }
      }

      return null;
    },
    updateSettings(){
      if ( this.chatOption.type !== 1 ){
        if ( this.hasCloud && !this.chatOption.number && !this.chatOption.parent_option_id ){
          this.$emit('setSetting', 'buttons_in_passive_flow', this.settingButtons)
        }
        if ( !this.chatOption.number && this.clearAllFlowDepartment ){
          this.$emit('setSetting', 'use_department_schedule', false)
        }
      }
    },
    submitData() {
      if ( !this.chatOption.description ) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Campo obrigatório!',
          text: 'A descrição da opção é obrigatória.'
        })
      }

      if ( this.chatOption.reason_id && !this.chatOption.reason_option_id ) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Campo obrigatório!',
          text: 'Após vincular um Modelo de Informação é necessário selecionar a Pergunta que será respondida no fluxo.'
        })
      }

      const acceptedKeys = Object.keys(this.startValue);
      const keysToRemove = Object.keys(this.chatOption).filter(key => !acceptedKeys.includes(key));
      keysToRemove.forEach(key => { delete this.chatOption[key]; });

      const that = this
      let chatOptionObj = this.$_.cloneDeep(this.chatOption)
      this.$validator.validateAll().then(result => {
        this.updateSettings()

        if (parseInt(this.selectedInteractionType) === 1) {
          chatOptionObj.number = null
        }

        if (result) {
          if (chatOptionObj.id !== null && chatOptionObj.id >= 0) {
            this.$store.dispatch("chatFlow/update", chatOptionObj).then(() => {
              that.setInitValues()
              this.$emit('closeSidebar')
              this.$emit('refetchChatFlow')
              this.$vs.notify({
                  title: "Sucesso",
                  text: "Fluxo atualizado com sucesso",
                  color: "success",
              });
            }).catch(err => {
              console.error(err)
            })
          } else {
            delete chatOptionObj.id
            this.$store.dispatch("chatFlow/add", chatOptionObj).then(() => {
              that.setInitValues()
              this.$emit('closeSidebar')
              this.$emit('refetchChatFlow')
              this.$vs.notify({
                  title: "Sucesso",
                  text: "Fluxo adicionado com sucesso",
                  color: "success",
              });
            }).catch(err => {
              console.error(err)
            })
          }
        }
      })
    }
  },
  async created() {
    if (!moduleChatFlow.isRegistered) {
      this.$store.registerModule('chatFlow', moduleChatFlow)
      moduleChatFlow.isRegistered = true
    }

    if (!moduleUserDepartment.isRegistered) {
      this.$store.registerModule('userDepartment', moduleUserDepartment)
      moduleUserDepartment.isRegistered = true
    }

    this.hasCloud = await hasCloud();
    await this.$store.dispatch("userDepartment/fetch")
    this.hasFeatures = (await hasFeature('orders')) || (await hasFeature('services'))
    this.settingButtons = !!parseInt(this.$store.state.settings.settings.buttons_in_passive_flow);
  },
  components: {
    vSelect,
    VuePerfectScrollbar
  }
}
</script>

<style lang="scss" scoped>
.align-items-center {
  align-items: center !important;
}

.settings-flow-panel {
  border: 3px dotted rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
  border-radius:10px;
}

.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
